import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

// core components
import Grid from "@material-ui/core/Grid";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { withSnackbar } from 'notistack';
import Table from "../../../views/Table";
import Typography from '@material-ui/core/Typography';
import GridItem from "../../../views/GridItem";
import GridContainer from "../../../views/GridContainer";
import Card from "../../../views/Card";
import CardHeader from "../../../views/CardHeader";
import CardBody from "../../../views/CardBody";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import { XYPlot, LabelSeries, HorizontalGridLines, VerticalBarSeries, XAxis, YAxis, FlexibleWidthXYPlot } from 'react-vis';
import 'react-vis/dist/style.css';
import { styles } from './styles';
import Apis from '../../../../utils/Apis'
import Workbook from 'react-excel-workbook'

const CustomAxisLabel = (props) => {
    const yLabelOffset = {
        y: props.innerHeight / 2 + props.title.length * 3,
        x: 10
    };

    const xLabelOffset = {
        x: props.innerWidth / 2,
        y: 1.45 * props.innerHeight
    };
    const transform = props.xAxis
        ? `translate(${xLabelOffset.x}, ${xLabelOffset.y})`
        : `translate(${yLabelOffset.x}, ${yLabelOffset.y}) rotate(-90)`;

    return (
        <g
            transform={transform}
        >
            <text fontSize="12" textAnchor="middle">{props.title}</text>
        </g>
    );
};

CustomAxisLabel.displayName = 'CustomAxisLabel';
CustomAxisLabel.requiresSVG = true;

class Analyze extends Component {

    state = {
        sites_count: 0,
        pageNumber: 1,
        sites: [],
        temp_page: [],
        sites_name: [],
        sites_id: [],

        types_name: [],
        types_id: [],

        export_sites: [],
        isLoading: false,
        open_register: false,
        data: [],
        options: [
            'All Types'
        ],
        selected: 'All Types',
    };

    async componentWillMount() {
        const { pageNumber } = this.state;
        await this.gettypes();
        await this.getSites();
        await this.getHistoryByAllType(pageNumber, 'All Types');
    }
    getHistoryByAllType = async (pageNumber, type_name) => {
        this.setState({ isLoading: true });
        try {
            let response = await Apis.getHistoryByAllType();
            let history = response.data;

            const { classes } = this.props;
            let temp = [];
            let temp_sites = [];
            var temp_chart = [];

            const { sites_id, sites_name } = this.state;
            for (let j = 0; j < sites_id.length; j++) {
                let name = sites_name[j];
                var working_hour = 0//this.convertMinsToDayHour(sites[i]['working_hour']);
                for (let i = 0; i < history.length; i++) {
                    if (history[i]['site_id'] == sites_id[j]) {
                        working_hour = working_hour + history[i]['working_hours'];
                    }
                }
                var json = {};
                json.x = name;
                json.y = working_hour;
                temp_chart.push(json);

                temp = [...temp,
                [

                    <Typography noWrap className={classes.typographyContent}>{j + 1}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{name}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{this.convertMinsToHrsMins(working_hour)}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{this.convertMinsToDayHour(working_hour)}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{type_name}</Typography>,
                ]
                ];
                temp_sites = [
                    ...temp_sites,
                    { No: j + 1, Name: name, 'Working Hours': this.convertMinsToDayHour(working_hour), Type: type_name }
                ];
            }
            const { pageNumber } = this.state;
            let temp_page = [];
            temp_page = temp;
            this.setState({ pageNumber: pageNumber, isLoading: false, sites_count: history.length, sites: temp, temp_page: temp_page, data: temp_chart, export_sites: temp_sites })
        }
        catch (error) {
            let messageProperty = Object.getOwnPropertyDescriptor(error, 'message');
            this.setState({ isLoading: false });
            this.props.enqueueSnackbar(messageProperty.value, {
                variant: 'error',
            });
        }
    }
    getHistoryByType = async (pageNumber, type_id, type_name) => {
        this.setState({ isLoading: true });
        try {
            let response = await Apis.getHistoryByType(type_id);
            let history = response.data;

            const { classes } = this.props;
            let temp = [];
            let temp_sites = [];
            var temp_chart = [];

            const { sites_id, sites_name } = this.state;
            for (let j = 0; j < sites_id.length; j++) {
                let name = sites_name[j];
                var working_hour = 0//this.convertMinsToDayHour(sites[i]['working_hour']);
                for (let i = 0; i < history.length; i++) {
                    if (history[i]['site_id'] == sites_id[j]) {
                        working_hour = working_hour + history[i]['working_hours'];
                    }
                }
                var json = {};
                json.x = name;
                json.y = working_hour;
                temp_chart.push(json);

                temp = [...temp,
                [

                    <Typography noWrap className={classes.typographyContent}>{j + 1}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{name}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{this.convertMinsToHrsMins(working_hour)}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{this.convertMinsToDayHour(working_hour)}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{type_name}</Typography>,
                ]
                ];
                temp_sites = [
                    ...temp_sites,
                    { No: j + 1, Name: name, 'Working Hours': this.convertMinsToDayHour(working_hour), Type: type_name }
                ];
            }

            const { pageNumber } = this.state;
            let temp_page = [];
            temp_page = temp;

            this.setState({ pageNumber: pageNumber, isLoading: false, sites_count: history.length, sites: temp, temp_page: temp_page, data: temp_chart, export_sites: temp_sites })


        }
        catch (error) {
            let messageProperty = Object.getOwnPropertyDescriptor(error, 'message');
            this.setState({ isLoading: false });
            this.props.enqueueSnackbar(messageProperty.value, {
                variant: 'error',
            });
        }
    }
    //get all types
    gettypes = async () => {
        try {
            let response = await Apis.getTypes();
            let types = response.data;

            const { classes } = this.props;
            let temp_types_name = ['All Types'];
            let temp_types_id = [];
            var index = 0;
            for (let i = 0; i < types.length; i++) {
                let type_id = types[i]['_id'];
                let name = types[i]['name'];

                temp_types_id = [
                    ...temp_types_id,
                    type_id
                ];
                temp_types_name = [
                    ...temp_types_name,
                    name
                ];
            }
            this.setState({ types_name: temp_types_name, types_id: temp_types_id })


        }
        catch (error) {
            let messageProperty = Object.getOwnPropertyDescriptor(error, 'message');
            this.props.enqueueSnackbar(messageProperty.value, {
                variant: 'error',
            });
        }
    }
    //get all types
    getSites = async () => {
        try {
            let response = await Apis.getSites();
            let sites = response.data;

            const { classes } = this.props;
            let temp_sites_name = [];
            let temp_sites_id = [];
            var index = 0;
            for (let i = 0; i < sites.length; i++) {
                let site_id = sites[i]['_id'];
                let name = sites[i]['name'];

                temp_sites_id = [
                    ...temp_sites_id,
                    site_id
                ];
                temp_sites_name = [
                    ...temp_sites_name,
                    name
                ];
            }
            this.setState({ sites_name: temp_sites_name, sites_id: temp_sites_id })


        }
        catch (error) {
            let messageProperty = Object.getOwnPropertyDescriptor(error, 'message');
            this.props.enqueueSnackbar(messageProperty.value, {
                variant: 'error',
            });
        }
    }

    // action for pagination
    handleChangePage = (event, page) => {
        const { pageNumber, sites } = this.state;
        this.setState({
            pageNumber: page + 1,
        });
    }
    convertMinsToDayHour = (minutes) => {
        var d = Math.floor(minutes / 480);
        var h = Math.floor(minutes % 480 / 60);
        var _d = h % 8;
        d = d < 0 ? 0 : d;
        _d = _d < 0 ? 0 : h;
        return (d == 0 && _d == 0) ? '0d' : (d + '.' + _d + 'd');
    }
    convertMinsToHrsMins = (minutes) => {
        var h = Math.floor(minutes / 60);
        var m = minutes % 60;
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        return h + 'h ' + m + 'min';
    }
    _onSelect = (option) => {
        const { types_name, types_id } = this.state;
        let index = types_name.findIndex(x => x == option.label);
        if (index == 0) {
            this.getHistoryByAllType(this.state.pageNumber, option.label);
        } else {
            this.getHistoryByType(1, types_id[index - 1], option.label);
        }

        this.setState({ selected: option });

    }
    render() {
        const { classes } = this.props;
        const { temp_page, sites_count, pageNumber, isLoading, data, export_sites, types_name } = this.state;
        const defaultOption = this.state.selected;
        return (
            <div>
                <GridContainer>
                    <div className={classes.topHeaderContainer}>
                        <div className={classes.leftContainer}>
                        </div>
                        <div className={classes.rightContainer}>

                            <Dropdown options={types_name} onChange={this._onSelect} value={defaultOption} placeholder="" />
                        </div>

                    </div>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info">
                                <h4 className={classes.cardTitleWhite}>总天数查看</h4>
                            </CardHeader>
                            <CardBody>
                                <Table
                                    tableHeaderColor="black"
                                    tableHead={[<b>No</b>, <b>Name</b>, <b>Working Hour</b>, <b>Working Day</b>, <b>Type</b>]}
                                    tableData={temp_page}
                                    handleChangePage={this.handleChangePage}
                                    containerHeight={400}
                                    totalCount={temp_page.length}
                                    rowsPerPage={5}
                                    page={pageNumber}
                                    isLoading={isLoading}
                                />
                                <Grid container xs={12} sm={12} md={12}>
                                    <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={11}>
                                    </Grid>

                                    <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={1}>
                                        <Workbook filename="analyze.xlsx" element={<Button variant="contained" color="primary" className={classes.btnUpdate} disableRipple>Export</Button>}>
                                            <Workbook.Sheet data={export_sites} name="Sheet A">
                                                <Workbook.Column label="No" value="No" />
                                                <Workbook.Column label="Name" value="Name" />
                                                <Workbook.Column label="Working Hours" value="Working Hours" />
                                                <Workbook.Column label="Type" value="Type" />
                                            </Workbook.Sheet>
                                        </Workbook>
                                    </Grid>
                                </Grid>
                            </CardBody>
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info">
                                <h4 className={classes.cardTitleWhite}>工地累计对比</h4>
                            </CardHeader>
                            <CardBody>
                                <FlexibleWidthXYPlot height={500} xType="ordinal" margin={{left: 80, top: 10, bottom: 150 }}>
                                    <HorizontalGridLines />
                                    <XAxis style={{
                                        ticks: { fill: 'black' },
                                        line: { display: 'none' }
                                    }}
                                        tickTotal={5}
                                        tickLabelAngle={-45}
                                    />
                                    <LabelSeries
                                        data={data.map(obj => {
                                            return { ...obj, label: this.convertMinsToDayHour(obj.y)}
                                        })}
                                        labelAnchorX="middle"
                                        labelAnchorY="text-after-edge"
                                    />

                                    <YAxis tickFormat={tick => this.convertMinsToDayHour(tick)} />
                                    <VerticalBarSeries data={data} />
                                    <CustomAxisLabel title={'Hour'} />
                                    <CustomAxisLabel title={`Site`} xAxis />
                                </FlexibleWidthXYPlot>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

Analyze.propTypes = {
    classes: PropTypes.object.isRequired
};

let mapStateToProps = (state) => {
    return {
        email: state.auth.email,
    };
}

export default withStyles(styles)(connect(mapStateToProps, null)(withSnackbar(Analyze)));